import axios from "axios";

const otpUrl = process.env.REACT_APP_OTP_SERVICE_BASE_URL;

export const createOTP = async (reqBody: any) => {
    // Return the response so calling code can await it properly
    const res = await axios.post(otpUrl+'creation', reqBody);
    return res;
}

export const validateOTP = (reqBody: any) => axios.post(otpUrl+'validation', reqBody);